
import { logout } from "../redux/slices/authSlice";
import { store } from "../redux/store";


let logoutTimer: any = null;
const INACTIVITY_LIMIT = 30 * 60 * 1000;

const activityEvents = [
  "click",
  "mousemove",
  "keydown",
  "scroll",
  "touchstart",
];

export const startSessionWatcher = () => {
  resetTimer();

  activityEvents.forEach((event) => {
    window.addEventListener(event, resetTimer);
  });
};

export const stopSessionWatcher = () => {
  activityEvents.forEach((event) => {
    window.removeEventListener(event, resetTimer);
  });
};

function resetTimer() {
  if (logoutTimer) clearTimeout(logoutTimer);

  logoutTimer = setTimeout(() => {
    store.dispatch(logout());
    stopSessionWatcher();
  }, INACTIVITY_LIMIT);
}
